import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cbad2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "personal-bindings",
  "aria-label": "个人绑定信息"
}
const _hoisted_2 = { class: "binding-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "绑定状态", -1))
const _hoisted_4 = {
  key: 0,
  class: "binding-error",
  role: "alert"
}

import {ref,computed,watch,onBeforeUnmount} from 'vue'
import {message} from 'ant-design-vue'
import store from '@/store'
import request from '@/utils/request'

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalBindingPanel',
  setup(__props) {

const kinds=[{key:'login',label:'微信扫码登录',tip:'解除后，该微信将不能扫码登录当前管理账号。确认解除？'},{key:'publicAccount',label:'公众号消息提醒',tip:'解除后停止当前管理账号的公众号提醒，站内消息保留。确认解除？'}]
const bindings=ref<Record<string,{bound:boolean;revision:string}>>({}),error=ref(''),loading=ref(false),busy=ref('')
const identity=computed(()=>JSON.stringify([store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId]))
let generation=0,disposed=false
function active(run:number,owner:string){return !disposed && generation===run && identity.value===owner}
function apply(data:any){if(Number(data?.accountId)!==Number(store.getters.userInfo?.id) || Number(data?.orgId)!==Number(store.getters.userInfo?.orgId))throw Error('账号已变化，请重新打开个人信息');for(const item of kinds)if(typeof data[item.key]?.bound!=='boolean' || !/^[a-f0-9]{64}$/.test(data[item.key]?.revision || ''))throw Error('绑定状态读取不完整，请刷新重试');bindings.value={login:data.login,publicAccount:data.publicAccount}}
async function refresh(){if(loading.value || busy.value || !store.getters.token)return;const run=generation,owner=identity.value;loading.value=true;error.value='';try{const {data}=await request.get('system/personalBindings');if(active(run,owner))apply(data)}catch(e:any){if(active(run,owner)){bindings.value={};error.value=e?.message || '绑定状态读取失败，请刷新重试'}}finally{if(active(run,owner))loading.value=false}}
async function unbind(kind:string){const item=bindings.value[kind];if(loading.value || busy.value || !item?.bound)return;const run=generation,owner=identity.value;busy.value=kind;error.value='';try{const {data}=await request.post('system/personalBindings/unbind',{kind,revision:item.revision});if(!active(run,owner))return;apply(data);if(bindings.value[kind]?.bound)throw Error('解除未完成，请刷新后重试');if(kind==='publicAccount'){const user={...store.getters.userInfo,ghOpenId:null};store.commit('user/setUserInfo',user);window.dispatchEvent(new Event('personal-public-binding-changed'))}else window.dispatchEvent(new Event('wechat-login-binding-changed'));message.success('已解除绑定')}catch(e:any){if(active(run,owner))error.value=e?.message || '解除绑定失败，请刷新后重试'}finally{if(active(run,owner))busy.value=''}}
watch(identity,()=>{generation++;bindings.value={};error.value='';loading.value=false;busy.value='';void refresh()},{immediate:true})
onBeforeUnmount(()=>{disposed=true;generation++})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_button, {
        size: "small",
        loading: loading.value,
        disabled: !!busy.value,
        onClick: refresh
      }, {
        default: _withCtx(() => [
          _createTextVNode("刷新状态")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(kinds, (item) => {
      return _createElementVNode("div", {
        key: item.key,
        class: "binding-row"
      }, [
        _createElementVNode("span", null, _toDisplayString(item.label), 1),
        _createElementVNode("span", null, _toDisplayString(loading.value?'读取中…':bindings.value[item.key] ? bindings.value[item.key].bound?'已绑定':'未绑定':'暂未获取'), 1),
        (bindings.value[item.key]?.bound)
          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
              key: 0,
              title: item.tip,
              "ok-text": "确认解除",
              "cancel-text": "取消",
              disabled: loading.value || !!busy.value,
              onConfirm: ($event: any) => (unbind(item.key))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  size: "small",
                  danger: "",
                  "aria-label": '解除'+item.label+'绑定',
                  loading: busy.value===item.key,
                  disabled: loading.value || !!busy.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("解除绑定")
                  ]),
                  _: 2
                }, 1032, ["aria-label", "loading", "disabled"])
              ]),
              _: 2
            }, 1032, ["title", "disabled", "onConfirm"]))
          : _createCommentVNode("", true)
      ])
    }), 64))
  ]))
}
}

})